module.exports = __webpack_public_path__ + "Tools-dd9dba10.png";